export default __webpack_public_path__ + "static/gigaclear-a61c92c5aeae23d9c987146d353dde6c.png";